<div class="audit-list">
  <div class="audit-list__header">
    <div class="audit-list__header-text">
      <h2>Audit Log</h2>
      <p>Track all changes made to this {{ entityType }}</p>
    </div>
    <div class="audit-list__controls">
      <div class="audit-list__search">
        <lds-input
          type="text"
          placeholder="Search audit events..."
          [formControl]="searchControl"
          class="audit-list__search-input">
          <lds-icon 
            name="search" 
            size="sm" 
            appearance="inherit"
            slot="prefix"
          ></lds-icon>
          <lds-icon 
            *ngIf="searchControl.value"
            name="close" 
            size="sm" 
            appearance="inherit"
            slot="suffix"
            (click)="searchControl.setValue('')"
            class="audit-list__search-clear"
          ></lds-icon>
        </lds-input>
      </div>
      <div class="audit-list__actor-filter" *ngIf="showActorFilter" data-testid="audit-actor-filter">
        <lds-choice-group
          identifier="auditActorCategory"
          name="auditActorCategory"
          [options]="actorFilterOptions"
          [selected]="selectedActorFilter"
          orientation="horizontal"
          (getChange)="onActorFilterChange($event)">
        </lds-choice-group>
      </div>
      <lds-button 
        variant="secondary" 
        size="sm"
        (click)="toggleSortOrder()"
        class="audit-list__sort-toggle"
      >
        <lds-icon 
          [name]="sortOrder === 'newest' ? 'arrow-down' : 'arrow-up'" 
          size="xs" 
          appearance="inherit"
        ></lds-icon>
        {{ sortOrder === 'newest' ? 'Newest first' : 'Oldest first' }}
      </lds-button>
    </div>
  </div>

  <div class="audit-list__content">
    <ng-container *appLoad="let auditEvents of auditEvents$">
      <ng-container *ngIf="auditEvents.length > 0; else noEvents">
        <div class="audit-events">
          <div 
            *ngFor="let event of auditEvents" 
            class="audit-event"
            [class.audit-event--expanded]="isExpanded(event.id)"
          >
            <!-- Compact View -->
            <lds-card 
              [isClickable]="true" 
              (click)="toggleEvent(event.id)"
              class="audit-event__card"
            >
              <div class="audit-event__header">
                <div class="audit-event__timestamp">
                  <lds-icon name="calendar" size="xs" appearance="inherit"></lds-icon>
                  <span>{{ event.timestamp | date:'medium' }}</span>
                </div>
                <div class="audit-event__type">
                  <lds-icon name="analytics" size="xs" appearance="inherit"></lds-icon>
                  <span>{{ event.eventType | eventType }}</span>
                </div>
                <div class="audit-event__origin">
                  <lds-icon name="user" size="xs" appearance="inherit"></lds-icon>
                  <span>{{ event.author }}</span>
                  <lds-tag
                    *ngIf="event.actorCategory"
                    [label]="event.actorCategory"
                    [appearance]="actorTagAppearance(event.actorCategory)"></lds-tag>
                </div>
                <div class="audit-event__expand">
                  <lds-icon 
                    [name]="isExpanded(event.id) ? 'arrow-up' : 'arrow-down'" 
                    size="xs" 
                    appearance="inherit"
                  ></lds-icon>
                </div>
              </div>

              <!-- Expanded Details INSIDE the card -->
              <div *ngIf="isExpanded(event.id)" class="audit-event__details">
                <div class="audit-event__details-content">
                  <div class="audit-event__detail-section">
                    <h4>Author</h4>
                    <p>{{ event.author }}<ng-container *ngIf="event.actorCategory"> ({{ event.actorCategory }})</ng-container></p>
                  </div>
                  <div class="audit-event__detail-section" *ngIf="event.participantName">
                    <h4>Participant</h4>
                    <p>{{ event.participantName }}</p>
                  </div>
                  <div class="audit-event__detail-section">
                    <h4>Event Type</h4>
                    <p>{{ event.eventType | eventType }}</p>
                  </div>
                  <div class="audit-event__detail-section">
                    <h4>Event Details</h4>
                    <pre class="audit-event__json" [innerHTML]="event.eventDetails | jsonFormat"></pre>
                  </div>
                </div>
              </div>
            </lds-card>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<!-- No Events Template -->
<ng-template #noEvents>
  <lds-empty-state
    *ngIf="hasActiveFilters; else noEventsAtAll"
    heading="No matching audit events"
    message="No events match the current search and actor filter."
  ></lds-empty-state>
</ng-template>

<ng-template #noEventsAtAll>
  <lds-empty-state
    heading="No audit events found"
    message="No changes have been recorded for this record yet."
  ></lds-empty-state>
</ng-template>

